'use client'

import type { Route } from 'next'
import { useRouter } from 'next/navigation'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import type { FlowType } from '@/features/cases'
import { SERVICE_META } from '@/features/investor/components/home/service-meta'

/** No case at all for this flow yet — the tab still exists, but it's a prompt to request the
 * service, not empty data. Ported from `DashboardHome.tsx`'s `NotRequestedCard`. */
export function NotRequestedCard({ flow }: { flow: FlowType }) {
  const router = useRouter()
  const service = SERVICE_META[flow]
  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-3 py-10 text-center">
        <p className="text-base font-semibold">{service.title}</p>
        <p className="text-muted-foreground max-w-sm text-sm">{service.promptCopy}</p>
        <Button onClick={() => router.push(service.startRoute as Route)}>{service.action}</Button>
      </CardContent>
    </Card>
  )
}
